var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "opening_hours_form",
      staticClass: "offcanvas offcanvas-right offcanvas-xl",
      attrs: { id: "opening_hours_form" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "opening_hours_form_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("openingHoursForm.title")) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "opening_hours_form_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("opening_hours_form")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _vm.form.helpers.openingHours
            ? _c(
                "div",
                [
                  _vm._l(
                    _vm.form.helpers.openingHours,
                    function (dailyOpeningHours, key) {
                      return _c(
                        "div",
                        {
                          key: key,
                          staticClass: "daily-working-hours",
                          class: key === "sunday" ? "mb-14" : "",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "daily-working-hours-switch" },
                            [
                              _c("BBSwitch", {
                                attrs: { label: _vm.$t("weekdays." + key) },
                                model: {
                                  value: dailyOpeningHours.on,
                                  callback: function ($$v) {
                                    _vm.$set(dailyOpeningHours, "on", $$v)
                                  },
                                  expression: "dailyOpeningHours.on",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !dailyOpeningHours.on,
                                      expression: "!dailyOpeningHours.on",
                                    },
                                  ],
                                  staticClass:
                                    "mobile-daily-working-hours-closed",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("openingHoursForm.closedLabel")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: dailyOpeningHours.on,
                                  expression: "dailyOpeningHours.on",
                                },
                              ],
                              staticClass: "daily-working-hours-selects",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "daily-working-hours-select" },
                                [
                                  _c("BBSelect", {
                                    attrs: {
                                      options: _vm.getTimeOptions(),
                                      placeholderHidden: true,
                                    },
                                    model: {
                                      value: dailyOpeningHours.from,
                                      callback: function ($$v) {
                                        _vm.$set(dailyOpeningHours, "from", $$v)
                                      },
                                      expression: "dailyOpeningHours.from",
                                    },
                                  }),
                                  _c("span", [_vm._v(" - ")]),
                                  _c("BBSelect", {
                                    attrs: {
                                      options: _vm.getTimeOptions(
                                        dailyOpeningHours.from
                                      ),
                                      placeholderHidden: true,
                                    },
                                    model: {
                                      value: dailyOpeningHours.to,
                                      callback: function ($$v) {
                                        _vm.$set(dailyOpeningHours, "to", $$v)
                                      },
                                      expression: "dailyOpeningHours.to",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !dailyOpeningHours.on,
                                  expression: "!dailyOpeningHours.on",
                                },
                              ],
                              staticClass: "daily-working-hours-closed",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("openingHoursForm.closedLabel"))
                              ),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.openingHours,
                          expression: "form.errors.openingHours",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.openingHours) + " ")]
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c(
              "button",
              {
                staticClass: "bb-btn btn-success ml-2",
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("openingHoursForm.saveBtn")) + " ")]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }